export enum CompositionOperationTypeEnum {
    ASSEMBLY = 1,
    KIT = 2
}
